import { createSelector } from 'reselect';
import { compose } from 'redux';
import getKey from '@utils/get-key';
import hasUniqueName from '@utils/has-unique-name';
import {
  selectMessageTraderHistory,
  selectShortlistData,
} from '../AppContainer/selectors';

export const selectCompany = state => state?.company || {};
export const selectSearch = state => getKey(state, 'search') || {};

export const selectCompanyData = compose(
  company => company.data || {},
  selectCompany,
);

export const makeSelectLoading = () =>
  createSelector(selectCompany, companyState =>
    getKey(companyState, 'loading'),
  );

export const selectUniqueNameFromProps = (_state, props) => {
  return props?.uniqueName;
};

export const getIsShortlisted = createSelector(
  selectUniqueNameFromProps,
  selectShortlistData,
  (uniqueName, shortlistData) => {
    if (!uniqueName) {
      return false;
    }

    return hasUniqueName(uniqueName, shortlistData);
  },
);

export const makeSelectError = () =>
  createSelector(selectCompany, companyState => getKey(companyState, 'error'));

export const selectAltTradesState = compose(
  state => state.altTrades,
  selectCompanyData,
);

export const selectAltTradesData = compose(
  state => state?.items,
  selectAltTradesState,
);

export const selectMessageHistory = createSelector(
  selectAltTradesData,
  selectMessageTraderHistory,
  (data, messageHistory) => {
    // Generate a keyed object of booleans for message history vs uniquename
    return (data || []).reduce(
      (prev, curr) => ({
        ...prev,
        [curr.uniqueName]: hasUniqueName(curr.uniqueName, messageHistory),
      }),
      {},
    );
  },
);
